export default {"src":"/_next/static/image/public/images/ic_vm_refer_earn_white.7be52a2cb0b7f909dc6d38631a89f9ed.svg","height":16,"width":18};